import { css } from '@emotion/css';
import { commonGenresStyle } from 'Shared/frontend/eventPosters/MusicPoster';
import { genreList } from 'Shared/common/Macros';
import { For } from 'solid-js';
import { Show } from 'solid-js';
import { nameStyle, maxTextLines} from 'Shared/frontend/Poster';
import { poster } from 'Shared/frontend/SettingsProvider';


export function FiveActs(P)
{
	const s = () => P.posterSettings;
	const theme = () => poster(s().theme,'fiveActs');

	const posterStyle = () => css({
		margin: '24px 0.2em 0 0.2em',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		gap: 14,
		textAlign: 'center'
	});

	const eventNameStyle = () => css(nameStyle(theme()), {
		padding: '.5em 0 .5em 0',
		width: '100%',
		...maxTextLines(3),
		fontSize: s().nameFontSize ?? theme().name.fontSize
	});


	const hide = () => s()?.hide ?? [];
	const showName = () => P.name && ! hide().includes('name');

	return (
		<div class={posterStyle()}>
			<Show when={showName()}>
				<div class={eventNameStyle()}>{ P.name }</div>
			</Show>

			<For each={P.lineup}>{item =>
				<Artist {...item} hide={hide()} 
					fontSize={s().artistNamesFontSize ?? theme().artistNames.fontSize} 
				/>
			}</For>
		</div>
	);
}

function Artist(P)
{
	const artistNameStyle = () => css({
		width: '100%', 
		fontSize: P.fontSize
	});

	const artistStyle = () => css({
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch'
	});

	const genresStyle = () => css(commonGenresStyle(), {
		fontSize: '0.7em'
	});

	return (
		<div class={artistStyle()}>
			<Show when={! P.hide.includes('artistName') && P.name}>
				<div class={artistNameStyle()}>{P.name}</div>
			</Show>
			<Show when={! P.hide.includes('artistGenres') && P.mainGenre}>
				<div class={genresStyle()}>{ genreList(P) }</div>
			</Show>
		</div>
	);
}

